"use client";

import CommonCreate from "@/components/common/Create";
import { useState } from "react";
import DriverForm from "./DriverForm";

const DriverCreate = () => {
  const [formProp, setFormProp] = useState({
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    password: "",
    driver_license: "",
    vehicle_id: 0,
    can_complete_order: "no"
  });

  return (
    <CommonCreate
      title="Create"
      resource="drivers"
      data={{
        ...formProp,
        vehicle_id: +formProp.vehicle_id,
        status: "OFFLINE",
        can_complete_order: formProp.can_complete_order === 'yes' ? true : false
      }}
      responseMessage="Driver created"
    >
      <DriverForm mode="create" formProp={formProp} setFormProp={setFormProp} />
    </CommonCreate>
  );
};

export default DriverCreate;
